import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

type HeaderProps = {
  companyName: string;
  periodStart: string;
  periodEnd: string;
};

function Header({ companyName, periodStart, periodEnd }: HeaderProps) {
  const { t } = useTranslation(["review", "formatter"]);

  return (
    <header className="mb-md">
      <Typography step="3" as="h1" weight="bold">
        {t("review:title", { companyName: companyName })}
      </Typography>
      <Typography step="1">
        {t("formatter:date", { value: new Date(periodStart) })}
        &nbsp;-&nbsp;
        {t("formatter:date", { value: new Date(periodEnd) })}
      </Typography>
    </header>
  );
}

export default Header;
